/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleDto } from '../../models/enrollment-schedule-dto';

export interface ScheduleLogControllerSearch$Params {
  ticketId: string;
  startDate: string;
  endDate: string;
  isCompleted?: boolean;
}

export function scheduleLogControllerSearch(http: HttpClient, rootUrl: string, params: ScheduleLogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, scheduleLogControllerSearch.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('isCompleted', params.isCompleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnrollmentScheduleDto>>;
    })
  );
}

scheduleLogControllerSearch.PATH = '/api/schedule-log/search';
